import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v1/file';

export class FileServiceV1 implements types.Handlers {
  private readonly endpoint = '/v1/files';

  constructor(private axios: AxiosInstance) {}

  async getFileById(params: types.GetFileByIdParameters): Promise<common.FileModelResponse> {
    const { data } = await this.axios.get<common.FileModelResponse>(
      `${this.endpoint}/${params.path.fileId}`,
    );
    return data;
  }

  async createBatchDownload(
    params: types.CreateBatchDownloadParameters,
  ): Promise<types.BatchDownloadResponse> {
    const { data } = await this.axios.post<types.BatchDownloadResponse>(
      `${this.endpoint}/batch-downloads`,
      params.body,
    );
    return data;
  }

  async deleteFile(params: types.DeleteFileParameters): Promise<void> {
    await this.axios.delete(`${this.endpoint}/${params.path.fileId}`);
  }

  async patchFile(params: types.PatchFileParameters): Promise<common.FileModelResponse> {
    const { data } = await this.axios.patch<common.FileModelResponse>(
      `${this.endpoint}/${params.path.fileId}`,
      params.body,
    );
    return data;
  }
}
